import gql from 'graphql-tag'

export default gql`
	mutation createProductAddition($required: ProductAdditionInput!) {
		cashAssist {
			createProductAddition(required: $required) {
				id
				name
				variants
			}
		}
	}
`
